import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabModule } from '@backbase/ui-ang';

import { BnViewSelectContextComponent } from './bn-view-select-context.component';
import { BnSelectContextExtendedModule } from 'bn-select-context-extended';
import { RouterModule } from '@angular/router';
import { SelectContextWidgetModule } from '@backbase/select-context-widget-ang';
import { UserContextConfigurationToken, SharedUserContextModule } from 'user-context';
import { environment } from 'src/environments/environment';
import { TemplateRegistry } from '@backbase/foundation-ang/core';
import { PUBSUB, PubSubService } from '@backbase/foundation-ang/web-sdk';


@NgModule({
  declarations: [
    BnViewSelectContextComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: '', component: BnViewSelectContextComponent }
    ]),
    BnSelectContextExtendedModule,
    SelectContextWidgetModule,
    SharedUserContextModule
  ],
  providers: [
    {
      provide: UserContextConfigurationToken,
      useValue: environment.landingPageUrl,
    },
    TemplateRegistry,
    {
      provide: PUBSUB,
      useExisting: PubSubService,
    },
  ],
})
export class BnViewSelectContextModule { }

